import SkyBlueWrapper from "../../theme/components/SkyBlueWrapper";
import {Container, Stack, Typography} from "@mui/material";
import {
    CloudUploadRounded,
    InsertDriveFileRounded,
    LinkRounded,
    SupervisedUserCircleRounded
} from "@mui/icons-material";

const Statistics = () => {
    return (
        <SkyBlueWrapper sx={{ mt: 10, py: {xs: 2.5, lg: 10} }}>
            <Container>
                <Stack direction={{lg: "row"}} alignItems="center" justifyContent={{ lg: "space-between" }} rowGap={{xs: 8, lg: 0}}>
                    <Stack direction={{lg: "row"}} alignItems="center" spacing={2}>
                        <CloudUploadRounded sx={{ fontSize: {xs: "5rem", lg: "4rem"} }}/>
                        <Stack alignItems={{xs: "center", lg: "initial"}} spacing={.5}>
                            <Typography variant="h6" fontSize={{ lg: "1.4rem " }} component="p">۵۱ ترابایت</Typography>
                            <Typography fontWeight={300}>ذخیره شده در سرور ابری</Typography>
                        </Stack>
                    </Stack>
                    <Stack direction={{lg: "row"}} alignItems="center" spacing={2}>
                        <InsertDriveFileRounded sx={{ fontSize: {xs: "5rem", lg: "4rem"} }}/>
                        <Stack alignItems={{xs: "center", lg: "initial"}} spacing={.5}>
                            <Typography variant="h6" fontSize={{ lg: "1.4rem " }} component="p">۱۵۴,۱۲۵ فایل</Typography>
                            <Typography fontWeight={300}>آپلود شده توسط کاربران</Typography>
                        </Stack>
                    </Stack>
                    <Stack direction={{lg: "row"}} alignItems="center" spacing={2}>
                        <SupervisedUserCircleRounded sx={{ fontSize: {xs: "5rem", lg: "4rem"} }}/>
                        <Stack alignItems={{xs: "center", lg: "initial"}} spacing={.5}>
                            <Typography variant="h6" fontSize={{ lg: "1.4rem " }} component="p">۱۰۷۳۳ کاربر</Typography>
                            <Typography fontWeight={300}>در حال استفاده از سرویس</Typography>
                        </Stack>
                    </Stack>
                    <Stack direction={{lg: "row"}} alignItems="center" spacing={2}>
                        <LinkRounded sx={{ fontSize: {xs: "5rem", lg: "4rem"} }}/>
                        <Stack alignItems={{xs: "center", lg: "initial"}} spacing={.5}>
                            <Typography variant="h6" fontSize={{ lg: "1.4rem " }} component="p">۴۱۵۳ لینک</Typography>
                            <Typography fontWeight={300}>ساخته شده توسط کاربران</Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Container>
        </SkyBlueWrapper>
    )
}
export default Statistics;